import { PropsWithChildren, ReactNode, Suspense, useState, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorMessage } from './Error'

export function NoSSR({ children, fallback }: PropsWithChildren<{ fallback?: ReactNode }>) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return fallback ? <>{fallback}</> : null

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  )
}
